export default "__VITE_ASSET__DZZm81Io__"